import {
  signUp,
  signIn,
  signOut,
  deleteUser,
  resetPassword,
  confirmSignUp,
  updatePassword,
  resendSignUpCode,
  confirmResetPassword,
} from "aws-amplify/auth";
import axios from "api/axios";

// App Backend
export const registerUser = async (userData) => {
  const response = await axios.post("/api/users/register", userData);
  return response.data;
};

// App Backend
export const getUserByCogId = async () => {
  try {
    const response = await axios.get("/api/users");
    return response.data;
  } catch (error) {
    console.error("Failed to get user:", error);
  }
};

// App Backend
export const updateUser = async (userData) => {
  const response = await axios.put("/api/users/profile", userData);
  return response.data;
};

// App Backend
export const sendPasswordResetConfirmationEmail = async (userEmail) => {
  console.log('Sending email to ', userEmail)
  const response = axios.post("/api/users/password-reset", { userEmail });
  console.log('Password change confirmation email response:', response);
}

export const sendFeedbackEmail = async (formData) => {
  try {
    const response = await axios.post("/api/users/feedback-email", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error submitting feedback:", error);
    throw error;
  }
};

// AWS Cognito
export const registerCognitoUser = async (userData) => {
  try {
    const user = await signUp({
      username: userData.email,
      password: userData.password,
      options: {
        userAttributes: {
          email: userData.email,
          "custom:role": "USER",
          "custom:isTrial": "true",
          "custom:firstName": userData.firstName,
          "custom:lastName": userData.lastName,
        },
      },
    });
    return user;
  } catch (error) {
    console.error("Failed to register Cognito user:", error);
    throw error;
  }
};

// AWS Cognito
export const resetPasswordCognitoUser = async (username) => {
  try {
    const result = await resetPassword({
      username,
    });
    return result;
  } catch (error) {
    console.error("Error resetting password:", error);
    throw error;
  }
};

// AWS Cognito
export const confirmResetPasswordCognitoUser = async (
  username,
  code,
  password
) => {
  try {
    const result = await confirmResetPassword({
      username,
      confirmationCode: code,
      newPassword: password,
    });
    return result;
  } catch (error) {
    console.error("Error confirm reset password:", error);
    throw error;
  }
};

// AWS Cognito
export const confirmSignUpCognitoUser = async (username, code) => {
  try {
    const { isSignUpComplete, nextStep } = await confirmSignUp({
      username,
      confirmationCode: code,
    });

    return { isSignUpComplete, nextStep };
  } catch (error) {
    console.error("Error confirming sign up:", error);
    throw error;
  }
};

// AWS Cognito
export const resendCodeCognitoUser = async (username) => {
  try {
    const codeSent = await resendSignUpCode({
      username: username,
    });

    return codeSent;
  } catch (error) {
    console.error("Error sending code:", error);
    throw error;
  }
};

// AWS Cognito
export const loginCognitoUser = async (username, password) => {
  try {
    const loginStatus = await signIn({
      username,
      password,
    });
    return loginStatus;
  } catch (error) {
    console.error("Failed to login Cognito user:", error);
    throw error;
  }
};

// AWS Cognito
export const logoutCognitoUser = async () => {
  try {
    await signOut();
    return true;
  } catch (error) {
    console.error("Failed to logout Cognito user:", error);
    throw error;
  }
};

// AWS Cognito
export const deleteCognitoUser = async (username, password) => {
  try {
    await signIn(username, password);
    await deleteUser();
  } catch (error) {
    console.error("Failed to delete Cognito user:", error);
    throw error;
  }
};

// AWS Cognito
export const updateCognitoUserPassword = async ({
  newPassword,
  oldPassword,
}) => {
  try {
    await updatePassword({
      newPassword,
      oldPassword,
    });
  } catch (error) {
    console.error("Failed to delete Cognito user:", error);
    throw error;
  }
};
